/**
 * Yandex Regions Configuration
 * 
 * Maps region codes to Russian names
 */

export interface Region {
  name: string
  code: string
  type: 'federal_city' | 'region' | 'country'
}

export const YANDEX_REGIONS: Record<string, Region> = {
  "1": {
    name: "Москва и Московская область",
    code: "1",
    type: "federal_city"
  },
  "10174": {
    name: "Санкт-Петербург и Ленинградская область",
    code: "10174",
    type: "federal_city"
  },
  "225": {
    name: "Вся Россия",
    code: "225",
    type: "country"
  },
  "11162": {
    name: "Екатеринбург и Свердловская область",
    code: "11162",
    type: "region"
  },
  "11316": {
    name: "Новосибирск и Новосибирская область",
    code: "11316",
    type: "region"
  },
  "11029": {
    name: "Ростов-на-Дону и Ростовская область",
    code: "11029",
    type: "region"
  },
  "10995": {
    name: "Краснодарский край",
    code: "10995",
    type: "region"
  },
  "11079": {
    name: "Нижегородская область",
    code: "11079",
    type: "region"
  },
  "11131": {
    name: "Самарская область",
    code: "11131",
    type: "region"
  },
  "11069": {
    name: "Ставропольский край",
    code: "11069",
    type: "region"
  },
  "11266": {
    name: "Иркутская область",
    code: "11266",
    type: "region"
  },
  "11095": {
    name: "Пензенская область",
    code: "11095",
    type: "region"
  },
  "977": {
    name: "Республика Крым",
    code: "977",
    type: "region"
  },
  "149": {
    name: "Беларусь",
    code: "149",
    type: "country"
  },
  "142": {
    name: "Донецк и Донецкая область",
    code: "142",
    type: "region"
  },
  "11176": {
    name: "Тюменская область",
    code: "11176",
    type: "region"
  }
}

/**
 * Get region name by code
 * 
 * @param regionCode - Region code (e.g., "225", "1")
 * @returns Region name in Russian or code if not found
 */
export function getRegionName(regionCode: string): string {
  const region = YANDEX_REGIONS[regionCode]
  return region ? region.name : `Регион ${regionCode}`
}

/**
 * Get all available regions as array
 * 
 * @returns Array of regions sorted by name
 */
export function getAllRegions(): Region[] {
  return Object.values(YANDEX_REGIONS).sort((a, b) => 
    a.name.localeCompare(b.name, 'ru')
  )
}

